import { InviteStatus, PackageStatus } from '@/Network/Types/Requests/HandoverInviteRequests'
import type {
  AdminQueueResponse,
  DoctorSummary,
  InviteResponseV2
} from '@/Network/Types/Responses/HandoverInviteResponses'

/**
 * Quem recebeu o plantão na troca — o outro lado do "Passou ⟶ Recebeu".
 *
 * O candidato do topo da fila é a resposta quando ele já aceitou (é ele quem é
 * efetivado na aprovação). Fora isso, vale o convite aceito mais antigo: a fila
 * é ordenada por aceite, então o primeiro a aceitar é o próximo da fila.
 * Retorna `null` enquanto ninguém aceitou.
 */
export const resolveTransferReceiver = (item: AdminQueueResponse): DoctorSummary | null => {
  if (item.currentCandidate?.status === InviteStatus.ACCEPTED) {
    return item.currentCandidate.doctor
  }

  const acceptedFirst = [...item.package.invites]
    .filter((invite): invite is InviteResponseV2 => invite.status === InviteStatus.ACCEPTED)
    .sort((a, b) => (a.acceptedAt ?? '').localeCompare(b.acceptedAt ?? ''))[0]

  return acceptedFirst?.doctor ?? null
}

/**
 * Texto que ocupa o lugar do receptor quando ninguém aceitou. Um pacote em
 * transição ainda pode ganhar um receptor — o convite está de pé e os médicos
 * não responderam; qualquer outro status já é desfecho.
 */
export const resolveEmptyReceiverLabel = (item: AdminQueueResponse): string => {
  if (item.package.status !== PackageStatus.PENDING) return 'Ninguém'

  const invitedCount = item.package.invites.length || item.totalInQueue
  return `${invitedCount} convidado${invitedCount === 1 ? '' : 's'} aguardando resposta`
}
